// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var Spice = require("@greenlabs/ppx-spice/src/rescript/Spice.bs.js");
var Js_dict = require("@rescript/std/lib/js/js_dict.js");
var Js_json = require("@rescript/std/lib/js/js_json.js");
var $$Storage = require("../Storage.bs.js");
var User_Type = require("./User_Type.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_Common = require("../type/Type_Common.bs.js");
var Type_String = require("../type/Type_String.bs.js");
var Util_Result = require("../util/Util_Result.bs.js");

function toString(value) {
  return value;
}

function fromString(str) {
  return {
          TAG: /* Ok */0,
          _0: str
        };
}

var UserToken_key = {
  TAG: /* Simple */0,
  _0: "LRTokenKey"
};

var UserToken = {
  key: UserToken_key,
  version: undefined,
  defaultValue: "",
  fromString: fromString,
  toString: toString
};

function userToken_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var token = Curry._1(Type_String.User.Token.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "token"), null));
  if (token.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              token: token._0
            }
          };
  }
  var e = token._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".token" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function toString$1(t) {
  return JSON.stringify(User_Type.t_encode(t));
}

function fromString$1(str) {
  var json = JSON.parse(str);
  var user = User_Type.t_decode(json);
  if (user.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: user._0
          };
  }
  var user$1 = userToken_decode(json);
  if (user$1.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: User_Type.make(undefined, undefined, undefined, user$1._0.token)
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: User_Type.disconnected
          };
  }
}

var Model_key = {
  TAG: /* WithDsPrefix */1,
  _0: "user"
};

var Model_version = "v5";

var Model = {
  key: Model_key,
  version: Model_version,
  defaultValue: User_Type.disconnected,
  fromString: fromString$1,
  toString: toString$1
};

var Main = $$Storage.Make(Model, $$Storage.LocalStorage);

var Token = $$Storage.Make(UserToken, $$Storage.LocalStorage);

var save = Main.save;

function setToken(token) {
  Belt_Option.forEach(Curry._1(Type_String.User.Token.toString, token), Token.save);
}

var get = Main.get;

function getProgression(dsId) {
  var user = Util_Result.toOption(Curry._1(get, undefined));
  return User_Type.getTimeProgressionById(dsId, user);
}

function setProgression(dsId, time, duration) {
  var user = Util_Result.toOption(Curry._1(get, undefined));
  var currentUser = user !== undefined ? user : Caml_option.some(User_Type.make(undefined, undefined, undefined, Type_String.User.Token.disconnected));
  var progression = Type_Common.Progression.makeFromTimeAndDuration(time, duration);
  if (progression === undefined) {
    return ;
  }
  var user$1 = User_Type.setTimeProgression(dsId, Caml_option.valFromOption(progression), currentUser);
  if (user$1 !== undefined) {
    return Curry._1(save, Caml_option.valFromOption(user$1));
  } else {
    return Curry._1(save, User_Type.disconnected);
  }
}

function Internal(funarg) {
  $$Storage.Make(Model, funarg);
  $$Storage.Make(UserToken, funarg);
  return {};
}

exports.Internal = Internal;
exports.getProgression = getProgression;
exports.setProgression = setProgression;
exports.get = get;
exports.save = save;
exports.setToken = setToken;
/* Main Not a pure module */
